import React, { useState, useEffect, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import ClearIcon from '@material-ui/icons/Clear'
import ProductContext from '../../../Product/context/product/productContext'
import { useLocation } from 'react-router-dom'
import {
    Button,
    ClickAwayListener,
    Grow,
    MenuItem,
    MenuList,
    Paper,
    Popper,
} from '@material-ui/core'
import { handleRedirectInternal } from '../../../Product/common/components'
import AuthContext from '../../../Product/context/auth/authContext'
import Loader from '../../../assets/loader'
import Loaders from '../../../Product/components/molecules/Loaders'

const HeaderSearchComponent = (props) => {
    const productContext = useContext(ProductContext)
    const authContext = useContext(AuthContext)
    const { productLocalState, setState: setProductState } = productContext
    const {
        isAuthenticated,
        recentSearch,
        responseStatus,
        clearResponse,
        recent_search,
        saveSearch,
        deleteSearch,
    } = authContext
    const [savedSearchMenu, setSavedSearchMenu] = useState(false)
    const [productLocation, setProductLocation] = useState([])
    const anchorRef = React.useRef(null)
    const isVarifiedGfTheme = global.storeConfigration?.bodyClass?.value === 'greenField'

    const [searchValues, setSearchValues] = useState({
        searchbar: '',
        est: 0,
        rat: 0,
        category: 0,
        sort: isVarifiedGfTheme ? '17' : '6',
        slimit: 50,
        view: 0,
    })
    const [loading, setLoading] = useState(false)

    const handleChange = (e) =>
        setSearchValues({ ...searchValues, [e.target.name]: e.target.value })

    const search1 = useLocation()
    let history = useHistory()
    const handleClear = (e) => {
        e.preventDefault()
        setSearchValues({ ...searchValues, searchbar: '' })
        history.push(`/search?q=`)
    }
    const handleClick = (e) => {
        e.preventDefault()
        history.push(
            `/search?q=${searchValues.searchbar}&est=${searchValues.est}&rat=${searchValues.rat}&cat=${searchValues.category}&view=${searchValues.view}&sort=${searchValues.sort}&slimit=${searchValues.slimit}`,
        )
    }
    useEffect(() => {
        setProductLocation(productLocalState.globalLocations)
    }, [productLocalState.globalLocations])

    useEffect(() => {
        const params = new URLSearchParams(window.location.search.substring(1))
        setSearchValues({
            ...searchValues,
            searchbar: params.get('q') ? params.get('q') : '',
            rat: params.get('rat') ? params.get('rat') : '',
            est: params.get('est') ? params.get('est').split(',') : '',
            category: params.get('cat') ? params.get('cat').split(',') : '',
        })
    }, [])

    useEffect(() => {
        if (isAuthenticated && recent_search) {
            setLoading(false)
        }
    }, [recent_search])
    const handleLocationChange = (locationValue) => {
        localStorage.setItem('globalLocation', locationValue)
        setProductState({
            ...productLocalState,
            globalLocation: locationValue,
        })
        if (
            window.location.pathname.includes('product-buyer-auction') ||
            window.location.pathname.includes('/product/')
        ) {
            // handleRedirectInternal(history, '')
            history.replace('/')
        }
    }

    const handlesavedSearchClick = (event, type) => {
        event.preventDefault()
        setSavedSearchMenu(!savedSearchMenu)
        if (type == 'open') {
            if (isAuthenticated) {
                setLoading(true)
                recentSearch({
                    page: 1,
                    sh_limit: 10,
                })
            }
        }
    }

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault()
            setSavedSearchMenu(false)
        }
    }
    const isBargainsProject = global.storeConfigration?.bodyClass2?.value === 'bargainsClass'
    return (
        <form className="nav-standard-top-area-search">
            <div className="nav-standard-top-area-search-inner">
                <div className="custom-state-city">
                    {isVarifiedGfTheme ? (
                        <>
                            {!isBargainsProject && (
                                <>
                                    {' '}
                                    <button
                                        ref={anchorRef}
                                        aria-controls={
                                            savedSearchMenu ? 'menu-list-grow' : undefined
                                        }
                                        aria-haspopup="true"
                                        className="userSearchField"
                                        onClick={(e) => handlesavedSearchClick(e, 'open')}
                                    >
                                        <span
                                            className="material-icons-outlined"
                                            title="Saved Search"
                                        >
                                            menu
                                        </span>
                                    </button>
                                    <Popper
                                        open={savedSearchMenu}
                                        anchorEl={anchorRef.current}
                                        role={undefined}
                                        transition
                                        disablePortal
                                        placement="bottom-start"
                                    >
                                        {({ TransitionProps, placement }) => (
                                            <Grow
                                                {...TransitionProps}
                                                style={{
                                                    transformOrigin: 'bottom start',
                                                }}
                                            >
                                                <Paper>
                                                    <ClickAwayListener
                                                        onClickAway={(e) =>
                                                            handlesavedSearchClick(e, 'close')
                                                        }
                                                    >
                                                        <MenuList
                                                            autoFocusItem={savedSearchMenu}
                                                            id="menu-list-grow"
                                                            onKeyDown={handleListKeyDown}
                                                        >
                                                            {loading ? (
                                                                <Loaders isLoading={true} />
                                                            ) : recent_search?.results.length >
                                                              0 ? (
                                                                recent_search?.results.map(
                                                                    (item, index) => {
                                                                        return (
                                                                            <MenuItem
                                                                                key={index}
                                                                                onClick={() => {
                                                                                    handleRedirectInternal(
                                                                                        history,
                                                                                        `search?q=${item.searchtext}&cat=&est=&rat=&view=&sort=17&slimit=50`,
                                                                                    )
                                                                                    setSearchValues(
                                                                                        (prev) => ({
                                                                                            ...prev,
                                                                                            searchbar:
                                                                                                item.searchtext,
                                                                                        }),
                                                                                    )
                                                                                }}
                                                                            >
                                                                                {item.searchtext}
                                                                            </MenuItem>
                                                                        )
                                                                    },
                                                                )
                                                            ) : (
                                                                <small className="px-3">
                                                                    No Search Item Was Saved
                                                                </small>
                                                            )}
                                                        </MenuList>
                                                    </ClickAwayListener>
                                                </Paper>
                                            </Grow>
                                        )}
                                    </Popper>
                                </>
                            )}
                        </>
                    ) : (
                        <>
                            <img src="/lots-images/loc.svg" alt="" />
                            <select
                                onChange={(e) => handleLocationChange(e.target.value)}
                                // onChange={(e) => setProductLocation(props.e.target.value)}
                                value={productLocalState.globalLocation}
                            >
                                {productLocation?.map((data, index) => (
                                    <option value={data} key={index}>
                                        {data === 'All' ? 'All locations' : data}
                                    </option>
                                ))}
                            </select>
                        </>
                    )}
                </div>
                {isVarifiedGfTheme ? (
                    <div className="headerSearchField">
                        <input
                            aria-label="search-header"
                            type="text"
                            onChange={(e) =>
                                setSearchValues((prev) => ({
                                    ...prev,
                                    searchbar: e.target.value,
                                }))
                            }
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    handleClick(e)
                                    if (props.onClose) {
                                        props.onClose()
                                    }
                                }
                            }}
                            name="searchbar"
                            value={searchValues.searchbar}
                            className="nav-standard-top-area-search-input open-sans"
                            placeholder="Search"
                        />
                        <button
                            className="filterUserSearch"
                            onClick={(e) => {
                                handleClick(e)
                                if (props.onClose) {
                                    props.onClose()
                                }
                            }}
                        >
                            <span className="material-icons-outlined">search</span>
                        </button>
                    </div>
                ) : (
                    <input
                        type="text"
                        onChange={handleChange}
                        name="searchbar"
                        value={searchValues.searchbar}
                        className="nav-standard-top-area-search-input open-sans"
                        placeholder="Search auctions"
                    />
                )}
                {/* <button
                    onClick={(e) => {
                        handleClick(e)
                        if (props.onClose) {
                            props.onClose()
                        }
                    }}
                    className="lin lin-magnifier nav-standard-top-area-search-sumbit"
                >
                    Advance Search
                </button> */}
                {/* <button
                    onClick={handleClear}
                    className="lin lin-magnifier nav-standard-top-area-search-clear"
                >
                    <ClearIcon />
                </button> */}
            </div>
        </form>
    )
}

export default HeaderSearchComponent
